import { render } from "./DeletedInfoServices.vue?vue&type=template&id=26f5e072&scoped=true"
import script from "./DeletedInfoServices.vue?vue&type=script&lang=js"
export * from "./DeletedInfoServices.vue?vue&type=script&lang=js"

import "./DeletedInfoServices.vue?vue&type=style&index=0&id=26f5e072&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f5e072"]])

export default __exports__